import CoverageService from "@/services/odoo/CoverageService";
import CoverageGroupService from "@/services/odoo/CoverageGroup";
import CoverageDescriptionService from "@/services/odoo/CoverageDescriptionService";

const coverageService = new CoverageService();
const coverageGroupService = new CoverageGroupService();
const coverageDescriptionService = new CoverageDescriptionService();

const state = {
  coverages: [],
  coverageGroups: [],
  coverageDescriptions: [],
  coverage: {},
  coverageRevision: null,
  processed: false
};

const getters = {
  getCoverages(state) {
    return state.coverages;
  },
  getCoverageDescriptions(state) {
    return state.coverageDescriptions;
  },
  coverageProcessed(state) {
    return state.processed;
  },
  getCoverage(state) {
    return state.coverage;
  },
  getCoverageGroups(state) {
    return state.coverageGroups;
  },
  coverageRevision(state) {
    return state.coverageRevision
  },
};

const actions = {
  fetchCoverages({commit}, params) {
    return new Promise((resolve, reject) => {
      coverageService.findAllByParams(params).then(response => {
        commit("SET_COVERAGE", response.data);
        resolve(response.data)
      }).catch(error => {
        reject(error);
      });
    });
  },
  fetchCoverageGroups({commit}, params) {
    return new Promise((resolve, reject) => {
      coverageGroupService.findAllByParams(params).then(response => {
        commit("SET_COVERAGE_GROUP", response.data);
        resolve(response.data)
      }).catch(error => {
        reject(error);
      });
    });
  },
  createCoverageDescription({commit}, {coverageDescription}) {
    return new Promise((resolve, reject) => {
      coverageDescriptionService.save(coverageDescription).then(response => {
        commit("CREATED_COVERAGE_DESCRIPTION", response.data);
        resolve(response.data);
      }).catch(error => {
          reject(error);
      });
    });
  },
  fetchCoverageDescriptions({commit}, id) {
    return new Promise((resolve, reject) => {
      coverageDescriptionService.findAll().then(response => {
        commit("SET_COVERAGE_DESCRIPTIONS", response.data);
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  fetchCoverage({commit}, id) {
     return new Promise((resolve, reject) => {
       coverageService.get(id).then(response => {
         commit("SET_COVERAGE", response.data);
         resolve(response.data);
       }).catch(error => {
         reject(error);
       });
     });
  },
  fetchCoverageRevision({commit}, id) {
    return new Promise((resolve, reject) => {
      coverageService.getRevision(id).then(response => {
        commit("SET_COVERAGE_REVISION", response.data);
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  },
   createCoverage({commit}, coverage) {
     return new Promise((resolve, reject) => {
       coverageService.save(coverage).then(response => {
         commit("CREATED_COVERAGE");
         resolve(response.data);
       }).catch(error => {
         reject(error);
       });
     });
  },
  updateCoverage({commit}, {id, coverage}) {
    return new Promise((resolve, reject) => {
      coverageService.update(id, coverage).then(response => {
        commit("UPDATED_COVERAGE");
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deleteCoverage({commit}, id) {
    return new Promise((resolve, reject) => {
      coverageService.delete(id).then(response => {
        commit("DELETED_COVERAGE");
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }
};

const mutations = {
  SET_COVERAGE_DESCRIPTIONS(state, data) {
    state.coverageDescriptions = data;
    state.processed = false;
  },
  CREATED_COVERAGE_DESCRIPTION(state, data) {
    state.coverageDescriptions.push(data);
    state.processed = false;
  },
  SET_COVERAGES(state, data) {
    state.coverages = data;
    state.processed = false;
  },
  SET_COVERAGE(state, data) {
    state.coverage = data;
    state.processed = false;
  },
  SET_COVERAGE_REVISION(state, data) {
    state.coverageRevision = data;
    state.processed = false;
  },
  SET_COVERAGE_GROUP(state, data) {
    state.coverageGroups = data;
    state.processed = false;
  },
  CREATED_COVERAGE(state) {
    state.processed = true;
  },
  UPDATED_COVERAGE(state) {
    state.processed = true;
  },
  DELETED_COVERAGE(state) {
    state.processed = true;
  },
  CLEAR_COVERAGE_DESCRIPTIONS(state) {
    state.coverageDescriptions = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
